import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectPasswordExpired, selectToken } from "./store/authSlice";

// Signed-in users only. A session with an expired password is parked on
// /reset-password until the password has been changed.
export default function ProtectedRoutes() {
    const token = useSelector(selectToken);
    const passwordExpired = useSelector(selectPasswordExpired);

    if (!token) return <Navigate to="/" replace />;
    if (passwordExpired) return <Navigate to="/reset-password" replace />;
    return <Outlet />;
}